export default {
  header: 'Steg',
  days: 'dager',
};
